// Mock data for BODY LINE GYM website

export const brand = {
  name: 'BODY LINE',
  tagline: 'UNISEX FITNESS GYM · MULTIPLE BRANCHES',
  phone: '+91 84820 31021',
  phoneRaw: '918482031021',
  whatsapp: '+91 84820 31021',
  whatsappRaw: '918482031021',
  logo: '/assets/logo.jpg',
};

export const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Plans', href: '#plans' },
  { label: 'Trainers', href: '#trainers' },
  { label: 'Branches', href: '#branches' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
];

export const aboutFeatures = [
  { label: 'Modern Equipment', icon: 'Dumbbell' },
  { label: 'Professional Trainers', icon: 'UserCheck' },
  { label: 'Friendly Environment', icon: 'HeartHandshake' },
  { label: 'Affordable Membership', icon: 'BadgeIndianRupee' },
  { label: 'Personal Guidance', icon: 'Target' },
];

export const whyUsItems = [
  { title: 'Certified Trainers', icon: 'ShieldCheck' },
  { title: 'Premium Equipment', icon: 'Dumbbell' },
  { title: 'Cardio Zone', icon: 'HeartPulse' },
  { title: 'Strength Training', icon: 'Weight' },
  { title: 'Weight Loss Programs', icon: 'Flame' },
  { title: 'Muscle Building', icon: 'Zap' },
  { title: 'Personal Training', icon: 'UserCog' },
  { title: 'Clean Environment', icon: 'Sparkles' },
  { title: 'Affordable Membership', icon: 'BadgeIndianRupee' },
  { title: 'Friendly Community', icon: 'Users' },
];

// Admission fee (one-time)
export const admissionFee = 500;

// Pricing per branch
export const branchPlans = {
  '2.0': {
    branchName: 'BODY LINE GYM 2.0',
    location: 'Monshatola',
    plans: [
      {
        duration: '3 MONTHS',
        price: '2100',
        period: '/quarter',
        perks: ['Full gym access', 'Group training', 'Personal guidance'],
        highlight: false,
        cta: 'Join Now',
      },
      {
        duration: '6 MONTHS',
        price: '3300',
        period: '/half year',
        perks: ['Full gym access', 'Diet consultation', 'Progress tracking', 'Group training'],
        highlight: false,
        cta: 'Join Now',
      },
      {
        duration: '12 MONTHS',
        price: '5000',
        period: '/year',
        perks: [
          'Full gym access',
          'Personal training sessions',
          'Diet & nutrition plan',
          'Priority support',
        ],
        highlight: true,
        badge: 'BEST VALUE',
        cta: 'Join Now',
      },
    ],
  },
  '5.0': {
    branchName: 'BODY LINE GYM 5.0',
    location: 'Panchla',
    plans: [
      {
        duration: '3 MONTHS',
        price: '2600',
        period: '/quarter',
        perks: ['Full gym access', 'Group training', 'Personal guidance'],
        highlight: false,
        cta: 'Join Now',
      },
      {
        duration: '6 MONTHS',
        price: '4000',
        period: '/half year',
        perks: ['Full gym access', 'Diet consultation', 'Progress tracking', 'Group training'],
        highlight: false,
        cta: 'Join Now',
      },
      {
        duration: '12 MONTHS',
        price: '6000',
        period: '/year',
        perks: [
          'Full gym access',
          'Personal training sessions',
          'Diet & nutrition plan',
          'Priority support',
        ],
        highlight: true,
        badge: 'BEST VALUE',
        cta: 'Join Now',
      },
    ],
  },
};

export const trainers = [
  {
    name: 'Kiron',
    role: 'FOUNDER & OWNER',
    experience: '15+ Years Experience',
    bio: 'Professional Fitness Coach & Owner. Leading Body Line Gym with a passion for transforming lives through disciplined, science-backed training.',
    isFounder: true,
    poster: '/assets/kiron.jpg',
    image: '/assets/kiron.jpg',
  },
  {
    name: 'Sintu Baiyan',
    role: 'Coach',
    experience: '6+ Years Experience',
    specialty: 'Strength & Conditioning · K11 Certified',
    poster: '/assets/sintu.jpg',
    image: '/assets/sintu.jpg',
  },
  {
    name: 'Kushal Adhikary',
    role: 'Coach',
    experience: '6+ Years Experience',
    specialty: 'Fitness Coach · NFNA Certified',
    poster: '/assets/nfna.jpg',
    image: '/assets/nfna.jpg',
  },
  {
    name: 'Poulomi Bag',
    role: 'Ladies Trainer',
    experience: '7+ Years Experience',
    specialty: "Women's Fitness · Weight Loss · Strength & Toning",
    poster: '/assets/poulomi.jpg',
    image: '/assets/poulomi.jpg',
  },
];

export const branches = [
  {
    tag: 'Monshatola',
    name: 'BODY LINE GYM 2.0',
    address: 'Monshatola, Near Coffee House Classic',
    mapsUrl: 'https://share.google/3QrdHmPhknqAouCTu',
    phone: '+91 84820 31021',
    phoneRaw: '918482031021',
  },
  {
    tag: 'Panchla',
    name: 'BODY LINE GYM 5.0',
    address: 'Panchla, Near Country Roads',
    mapsUrl: 'https://maps.app.goo.gl/FWnmEvdB6qHNxY8b7',
    phone: '+91 84820 31021',
    phoneRaw: '918482031021',
  },
];

export const timings = [
  {
    label: 'MORNING',
    time: '6:00 AM – 1:00 PM',
    days: 'Every day (Mon – Sat)',
    icon: 'Sun',
    tone: 'light',
  },
  {
    label: 'EVENING',
    time: '4:00 PM – 10:00 PM',
    days: 'Every day (Mon – Sat)',
    icon: 'Moon',
    tone: 'light',
  },
  {
    label: 'SUNDAY',
    time: 'Closed',
    days: 'Rest & recovery day',
    icon: 'CalendarX',
    tone: 'dark',
  },
];

export const social = {
  instagram: 'https://www.instagram.com/bodylinegym.india?utm_source=qr&igsh=MW95OGZiZXRhamd1Ng==',
  facebook: 'https://www.facebook.com/share/1BhMJooCQC/',
  youtube: '#',
};

export const galleryImages = [
  { src: '/assets/gym-poster.jpg', caption: 'Body Line Unisex Gym · Stronger Body, Stronger Mind, Stronger You' },
  { src: '/assets/gym-interior.jpg', caption: 'Modern Equipment & Neon Interior' },
  { src: '/assets/gym-bodybuilders.jpg', caption: 'Our Champions in Action' },
  { src: '/assets/gym-group.jpg', caption: 'Grand Opening · Community Event' },
  { src: '/assets/gym-ladies.jpg', caption: 'Ladies Fitness Zone' },
];

export const heroBg = 'https://images.pexels.com/photos/36877065/pexels-photo-36877065.jpeg?auto=compress&cs=tinysrgb&w=2000&q=85';
export const aboutImage = '/assets/gym-bodybuilders.jpg';
export const kironPosterImage = 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?crop=entropy&cs=srgb&fm=jpg&w=1400&q=90';
